<template>
  <div
    :class="componentClasses"
  >
    <Icon
      :icon="icon"
      class="stk-confidence-icon"
      resize="3"
    />
    <span v-if="!hideLabel">{{ properName }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { prettifyMixedCase } from '@frontend/shared/Util.js';
import Icon from './Icon.vue';

const props = defineProps({
  confidence: {
    type: String,
    default: 'unknown',
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
});

const properName = computed(() => prettifyMixedCase(props.confidence));
const lowerName = computed(() => props.confidence.toLowerCase());

const ICON_MAP = {
  'unknown': 'fas fa-question',
  'low': 'fas fa-times',
  'medium': 'far fa-circle',
  'high': 'fas fa-circle',
};

const icon = computed(() => {
  return ICON_MAP[lowerName.value] || 'fas fa-question';
});

const componentClasses = computed(() => [
  'stk-confidence-level',
  lowerName.value && `is-${lowerName.value}`,
]);
</script>

<style>
.stk-confidence-level {
  display: inline-flex;
  align-items: center;
  gap: 0.25em;

  &.is-unknown {
    color: inherit;
  }

  &.is-high {
    color: var(--stk-success-50);
  }

  &.is-medium {
    color: var(--stk-warning-50);
  }

  &.is-low {
    color: var(--stk-danger-50);
  }

  .stk-confidence-icon {
    flex-shrink: 0;
    height: 1.125em;
    width: 1.125em;
    color: inherit !important;
  }
}
</style>
